/**
 * Load page batch
 */
class LoadPageBatch extends HTMLElement {
  sectionId = this.getAttribute('id');
  pages = parseInt(this.getAttribute('pages'));
  currentPage = parseInt(this.getAttribute('current-page'));
  pageSize = parseInt(this.getAttribute('page-size'));

  connectedCallback() {
    this.buttons = this.querySelectorAll('[data-batch-direction]');
    this.buttons.forEach((button) => {
      button.addEventListener('click', () => this.handleBatch(button));
    });

    window.onpopstate = () => {
      this.handleBatch();
    };
  }

  loading(state = true) {
    state ? this.setAttribute('loading', '') : this.removeAttribute('loading');
  }

  handleSearchParams() {
    if (!this.direction) return;
    this.searchParams = new URLSearchParams(document.location.search);

    let theNewPage = this.currentPage;
    if (this.direction === 'next') {
      theNewPage = parseInt(this.getAttribute('page-next')) + 1;
    } else if (this.direction === 'previous') {
      theNewPage = parseInt(this.getAttribute('page-previous')) - 1;
    }

    // New page must be in pagination range, stop if not
    if (theNewPage > this.pages && theNewPage < 1) return;
    this.newPage = theNewPage;

    this.searchParams.set('page', this.newPage);
    this.searchParams.delete('section_id');
    this.clientUrl = document.location.pathname + '?' + this.searchParams.toString();

    this.searchParams.set('section_id', this.sectionId);
    this.fetchUrl = document.location.pathname + '?' + this.searchParams.toString();
  }

  async handleBatch(button) {
    this.direction = button?.dataset?.batchDirection || 'current';
    this.loading();
    this.handleSearchParams();
    try {
      const html = await this.getHtml();
      this.render(html);
      window.history.pushState({}, '', this.clientUrl);

      button?.dataset?.batchDirection === 'next'
        ? this.setAttribute('page-next', this.newPage)
        : this.setAttribute('page-previous', this.newPage);
    } catch (error) {
      console.log(error);
    } finally {
      this.loading(false);
    }
  }

  async getHtml() {
    const response = await fetch(this.fetchUrl);

    if (!response.ok) {
      throw new Error(response);
    }
    const text = await response.text();

    const html = new DOMParser()
      .parseFromString(text, 'text/html')
      .querySelector('[data-batch="list"]').innerHTML;

    return html;
  }

  render(html) {
    this.list = this.querySelector('[data-batch="list"]');

    if (!html || !this.list) return;

    // Add new content before or after the current content
    if (this.direction === 'next') {
      this.list.insertAdjacentHTML('beforeend', html);
      this.scrollIntoView({ behavior: 'smooth', block: 'end', inline: 'nearest' });
    } else if (this.direction === 'previous') {
      this.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
      this.list.insertAdjacentHTML('afterbegin', html);
    } else {
      this.list.innerHTML = html;
      this.scrollIntoView({ behavior: 'smooth', block: 'start', inline: 'nearest' });
    }
    this.currentPage = this.newPage;
    this.setAttribute('current-page', this.currentPage);

    this.currentPage === 1
      ? this.querySelector('[data-batch-direction="previous"]').classList.add('hidden')
      : null;

    this.currentPage === this.pages
      ? this.querySelector('[data-batch-direction="next"]').classList.add('hidden')
      : null;

    // Update the optional items viewed count
    const itemsViewed = this.querySelector('[data-batch="items-viewed"]');
    const countItems = this.querySelectorAll('[data-batch="item"]').length || null;
    if (!itemsViewed || !countItems) return;
    itemsViewed.textContent = countItems;
  }
}

if (!customElements.get('load-page-batch')) {
  customElements.define('load-page-batch', LoadPageBatch);
}
